export default {
  search: 'Search',
  upload: 'Upload',
  folderId: 'Folder ID',
  author: 'Author',
  modified: 'Modified',
  volume: 'Volume',
  quantity: 'Quantity',
  activities: 'Activities',
  name: 'Name',
  connectedPage: 'Connected Page',
  renameFolder: 'Rename Folder',
};
